import { initSubRoutes } from '../../../utils/router';

const RoutesNotifications = initSubRoutes({
    route: '/notifications',
    subroutes: {},
    nom: 'Notifications',
});

export default RoutesNotifications;
